import React from 'react';
import Spinner from '../UI/Spinner/spinner';
import css from './bfm.css';
class FastlinkRedirect extends React.Component {

  componentDidMount() {
    const token = this.props.location.hash.slice(1);
    const { bookId } = this.props.match.params;

    if (token.length > 10) {
      localStorage.setItem('token', token);
      localStorage.setItem('bookid', bookId);
   }
  window.parent.postMessage('goToYodlee','*');
  }

  render() {
    return (
    <div className={css.note}>
      <Spinner small />
      <div className={css.muted}>Connecting to Yodlee</div>
    </div>);
  }
}

export default FastlinkRedirect;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/FastLinkRedirect.js